import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { settingsApi } from '@/api/endpoints/settings';
import { useAuthStore } from '@/stores/authStore';
import { setDefaultFormats } from '@/utils/format';

/**
 * Syncs the active company's date_format and time_format preferences
 * into the module-level defaults used by formatDate / formatTime / formatDateTime.
 * Renders nothing — mount once near the app root, inside QueryClientProvider.
 */
export default function CompanyFormatsProvider() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const activeCompanyId = useAuthStore((s) => s.activeCompanyId);

  const { data: company } = useQuery({
    queryKey: ['company/current'],
    queryFn: () => settingsApi.getCurrentCompany().then(r => r.data),
    enabled: isAuthenticated && !!activeCompanyId,
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (company) {
      setDefaultFormats(
        company.date_format || 'DD MMM YYYY',
        company.time_format || '24h',
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company?.date_format, company?.time_format]);

  return null;
}
